import Api from '@common/services/api';
import { APIEvaluationForm, EvaluationFormPayload } from '../types';

export const updatePerformanceForm = async (
    organisationId: string,
    id: string,
    payload: EvaluationFormPayload
  ) => {
    return Api.put<{ data: APIEvaluationForm }>(
      `/v1/organisations/${organisationId}/performance/forms/${id}`,
      payload
    );
  };
